var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006DC9",
    fillRule: "evenodd",
    stroke: "#006DC9",
    strokeWidth: 0.5,
    d: "M3.5 3.5c0 .052-.02.102-.054.139L.814 6.443c-.072.076-.188.076-.26 0-.072-.077-.072-.201 0-.278L3.056 3.5.554.835C.482.758.482.635.554.557c.072-.076.188-.076.26 0l2.632 2.804c.035.037.054.087.054.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPointer);
export default __webpack_public_path__ + "static/media/arrow-right-pointer.ce1a63be0fcaf8e97d0ebceb3058fa47.svg";
export { ForwardRef as ReactComponent };